<template>
  <div class="VueNode">
    <ul>
      <li
        v-for="(item, index) in myData.WxApp"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="li_left">
          <img :src="item.img[0]" alt="" />
        </div>
        <div class="li_right">
          <p class="title">
            <span>{{ item.title }}</span>
          </p>
          <p class="detail">
            <span>{{ item.detail }}</span>
          </p>
          <p class="price">
            <span v-if="item.price">￥{{ item.price }}</span>
          </p>
          <el-button type="danger" @click="goDetail(item)">查看详情</el-button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ShopdmVueNode",

  data() {
    return {};
  },
  computed: {
    ...mapState(["myData"]),
  },
  mounted() {
    localStorage.getItem("theme") === "dark"
      ? this.$bus.$emit("theme-change", localStorage.getItem("theme"))
      : "";
  },

  methods: {
    goDetail(item) {
      this.$router.push({
        path: "/Detail",
        query: {
          item,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.VueNode {
  ul {
    overflow: hidden;
    li {
      display: flex;
      align-items: center;
      padding: 0 10px;
      height: 180px;
      border-bottom: 1px solid #eee;
      background-color: #fff;
      .li_left {
        border-radius: 10px;
        overflow: hidden;
        width: 150px;
        height: 150px;
        img {
          width: 100%;
        }
      }
      .li_right {
        flex: 1;
        height: 90%;
        position: relative;
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        p {
          display: flex;
          align-items: center;

          & span:nth-child(1) {
            font-size: 20px;
            flex: 1;
            line-height: 25px;
          }
        }
        .detail {
          height: 50px;
          & span:nth-child(1) {
            height: 85%;
            overflow: hidden;
            color: #545454;
            font-size: 14px;
            line-height: 20px;
            text-overflow: ellopsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .price {
          & span:nth-child(1) {
            color: #fd3f31;
          }
        }
        /deep/ .el-button {
          transition: all 0.3s;
          position: absolute;
          background-color: #fff;
          border: 1px solid #eee;
          bottom: 10px;
          right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 110px !important;
          height: 40px !important;
          span {
            font-size: 18px !important;
            transform: scale(0.8);
            color: #9a9a9a !important;
          }
        }
        & /deep/ .el-button:hover {
          background-color: #ff4d4f;
          span {
            color: #fff !important;
          }
        }
      }
    }
  }
}
</style>
